import { useDispatch, useSelector } from 'react-redux';

import { StatusEnum } from '@common/constants';
import { useIgnoreEffectDeps } from '@common/hooks';

import { getLanguages, getLanguagesStatusSelector } from '../store';

export function useFetchLanguages() {
  const status = useSelector(getLanguagesStatusSelector);
  const dispatch = useDispatch();

  useIgnoreEffectDeps(() => {
    if ([StatusEnum.Uninitialized, StatusEnum.Rejected].includes(status)) {
      dispatch(getLanguages());
    }
  }, []);
}
